import {Feature} from "geojson";
import {Geometry} from "wkx";

export function getGeomStringForFeature (feature: Feature) {
    try {
        return Geometry.parseGeoJSON(feature.geometry).toEwkt();
    } catch (e) {
        console.error(e);
    }
}